import { connect } from 'react-redux'
import { compose } from 'redux'
import { reduxForm } from 'redux-form'

import { BookingTableCellsBase } from './BookingTableCells'

import { mainCitiesSelector, fromCityTypeByLabelSelector } from 'reduxModules/selectors/CitySelectors'

const mapStateToProps = (state, props) => ({
  mainCities: mainCitiesSelector(state, props),
  initialValues: props.isEditing ? { ...props.booking } : {},
  fromCityTypeByLabel: fromCityTypeByLabelSelector(state, props),
})

const enhance = compose(
  connect(mapStateToProps),
  reduxForm({
    form: 'booking',
    enableReinitialize: true
  }, mapStateToProps),
)

export const BookingTableCells = enhance(BookingTableCellsBase)



// WEBPACK FOOTER //
// ./src/components/Bookings/components/BookingTableCells/index.js